module.exports = __webpack_public_path__ + "img/symbol_2.eee40f50.png";